export const PLAN_KEYS = ["free", "pro", "business"];
export const LIMIT_KEYS = ["products", "staff", "devices"];
export const daysLeft = (iso) => (iso ? Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 864e5)) : 0);
export const STATUS_TONE = { trial: "#2B79C2", active: "#1F9D55", expired: "#E67E22", free: "#5F6B76", suspended: "#D93838" };
